import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthenticationService } from '../_services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductoService } from '../_services/producto.service';
import { DomSanitizer } from '@angular/platform-browser';
import { interval } from 'rxjs';
import { take } from 'rxjs/operators';


@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {
  public productos: any[] = [];
  constructor(
    private authService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private productoService: ProductoService,
    private sanitizer: DomSanitizer,
  ) {
  }

  ngOnInit(): void {
    const idAplicacion = this.activatedRoute.snapshot.params.idAplicacion;
    var redirectUrl = this.activatedRoute.snapshot.queryParams.redirectUrl;
    if (redirectUrl == undefined)
      redirectUrl = "";
    this.productoService.setCurrentApp(idAplicacion);
    this.authService.logoutUser().subscribe(result => {
      this.productos = result;
      // interval(3000).pipe(take(1)).subscribe(() => {
      const productoActual = this.productos.find(n => n.id == idAplicacion);
      if (productoActual) {
        window.open(productoActual.urlBase + redirectUrl, '_self');
      } else {
        this.router.navigate(['/login', { idAplicacion }]);
      }
      // });
    });
  }

  getUrl(prod: any) {
    const url = prod.urlBase + prod.logoutUrl;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
